import { useState, useEffect } from 'react';
import axios from 'axios';
import CoachesSection from '../components/sections/CoachesSection';
import DoctorsSection from '../components/sections/doctorsSection';
import InternsSection from '../components/sections/InternsSection';
import Head from "next/head";
import Link from "next/link";
import urlSet from '../utils/urls';

const About = () => {
  const [employees, setEmployees] = useState({
    doctor: [],
    intern: [],
    coach: [],
  });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getEmployees= async () => {
            try {
                let url = urlSet.viewEmployeesApi.url;
                setLoading(true);
                const res = await axios.get(encodeURI(url));
                const temp = {
                  doctor: [],
                  intern: [],
                  coach: []
                };
                res.data.forEach(emp => {
                  temp[emp.role].push(emp)
                })
                setEmployees(temp);
                setLoading(false);
            } catch (err) {
                setLoading(false);
            }
        };

        getEmployees();
    }, []);

  return (
    <div>
      <Head>
        <meta property="og:image" content={"https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"} />
        <title>About Optimum Wellness | World's Leading Fitness and Wellness Platform</title>
        <meta name="description" content="Optimum Wellness is the only community providing research-backed solutions to improve your overall fitness, nutrition, and wellness. We focus on intellectual wellness, social wellness, financial wellness, dietary wellness, physical wellness, emotional (psychological) wellness, occupational wellness, environmental wellness, spiritual wellness and sexual wellness." />
      </Head>
      <div className="ps-3 pe-3 ps-xl-5 pe-xl-5 mt-4 mt-xl-0">
        <div className="row m-0 ps-lg-5 pe-lg-5">
          <div className="col-sm-7 m-auto">
            <img src="/assets/about.png" className="w-100" alt='image'></img>
          </div>
          <div className="col-sm-5 m-auto">
            <div className="fo-70 bco fw-700 mfo-28 lg-48 ms-lg-5 d-none d-sm-block">About <br></br>Optimum <br></br>Wellness</div>
            <div className="fo-26 bco fw-700 text-center mt-4 d-sm-none">About Optimum Wellness</div>
          </div>
        </div>

        <div className="ps-lg-5 pe-lg-5">
          <div className="ps-lg-5 pe-lg-5">
            <div className="ps-lg-5 pe-lg-5 mt-5">
              <div className="ps-3 pe-3 ps-sm-5 pe-sm-5">
                <h1 className="fo-36 fw-700 bco text-center mfo-24">OUR STORY</h1>
                <div className="fo-14 mt-4 justify">Optimum Wellness is the world’s leading and only platform that’s been established to provide research-backed diversified solutions to holistically elevate an individual’s status of wellness. An individual’s wellness is influenced by an increasingly broad scope of factors that most lifestyle coaches have an inadequate understanding of and as a consequence of which most people find themselves struggling to find fulfillment in their life. <br></br><br></br>Optimum Wellness provides integrated lifestyle advice considering all influential factors of a person’s wellness, such as their intellectual wellness, social wellness, financial wellness, dietary wellness, physical wellness, emotional(psychological) wellness, occupational wellness, environmental wellness, spiritual wellness and sexual wellness. <br></br><br></br>We are currently majorly prioritizing the physical and dietary aspects of wellness and shall soon be rolling out programmes to optimize other aspects of wellness. Our mission is to optimize the wellness of the entire world at large!</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="aboutContainer d-none d-md-block">
        <div className="row m-0">
          <div className="col-md-6 text-center p-md-5">
            <div className='aboutContainerImg w-50'>
              <img src="/assets/about1.png" className="w-100" alt='image'></img>
            </div>
            <div className="fo-26 text-white fw-700 mt-4">ALAN BAPTIST</div>
            <div className="fo-24 text-white fw-700 mt-1">CEO & FOUNDER</div>
            <div className="fo-14 text-white mt-4 justify">India’s First Optimum Wellness Coach, Alan Baptist is a young entrepreneur with a powerful vision of empowering individuals by positively transforming various aspects of their lifestyles ranging from optimum physical and dietary wellness to psychological, financial, social, spiritual and other critical and popular facets of wellness.
              <br></br><br></br>Owing to Alan’s wealth of experience owing to his exposure in various fields across and the Optimum Wellness brand was founded to offer phenomenal fine-tuned counseling with respect to various aspects of an individual’s life.
              <br></br><br></br>He is a Nutrition certified nutritionist (Canada), and has also completed studying MAC-nutrition evidence-based course (UK) and the International Sports and Science Association (ISSA) certified trainer course,  after which he started scientifically educating people about fitness and nutrition and has successfully impacted on and transformed the lives of over 20000+ people effectively.
              <br></br><br></br>He is on a mission to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. </div>
          </div>

          <div className="col-md-6 text-center p-md-5">
            <div className='aboutContainerImg w-50'>
              <img src="/assets/about2.png" className="w-100" alt='image'></img>
            </div>
            <div className="fo-26 text-white fw-700 mt-4">VINIT BAPTIST</div>
            <div className="fo-24 text-white fw-700 mt-1">CEO & FOUNDER</div>
            <div className="fo-14 text-white mt-4 justify">India’s First MNU Certified Nutrition Fitness Coach, Vinit Baptist is the President and Founder of Optimum Wellness and he is well-versed with topics related to fitness and nutrition. He is always learning, teaching and coaching people the latest that has been proven in the field of fitness and nutrition.
              <br></br><br></br>He has educated numerous people about fitness and nutrition and that number is growing every day. You will find him talking to people about exercises, mobility, nutrition, weight training and strength and conditioning among other topics.
              <br></br><br></br>He has successfully set up four gyms across Kolkata under the brand name ZEST FITNESS STUDIO and plans to expand further globally. He is considered to be an authority and icon by various fitness professionals and he has conducted various successful workshops on nutrition, client assessment and exercise fundamentals.
              <br></br><br></br>He is on a quest to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. </div>
          </div>
        </div>
      </div>


      <div className="aboutContainer d-md-none">
        <div className="text-center p-sm-4">
          <img src="/assets/about1.png" className="w-50" alt='image'></img>
          <div className="fo-26 text-white fw-700 mt-4">ALAN BAPTIST</div>
          <div className="fo-24 text-white fw-700 mt-1">CEO & FOUNDER</div>
          <div className="fo-14 text-white mt-4 justify">India’s First Optimum Wellness Coach, Alan Baptist is a young entrepreneur with a powerful vision of empowering individuals by positively transforming various aspects of their lifestyles ranging from optimum physical and dietary wellness to psychological, financial, social, spiritual and other critical and popular facets of wellness.
            <br></br><br></br>Owing to Alan’s wealth of experience owing to his exposure in various fields across and the Optimum Wellness brand was founded to offer phenomenal fine-tuned counseling with respect to various aspects of an individual’s life.
            <br></br><br></br>He is a Nutrition certified nutritionist (Canada), and has also completed studying MAC-nutrition evidence-based course (UK) and the International Sports and Science Association (ISSA) certified trainer course,  after which he started scientifically educating people about fitness and nutrition and has successfully impacted on and transformed the lives of over 20000+ people effectively.
            <br></br><br></br>He is on a mission to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. </div>
        </div>
      </div>


      <div className="aboutContainer d-md-none">
        <div className="text-center p-sm-4">
          <img src="/assets/about2.png" className="w-50" alt='image'></img>
          <div className="fo-26 text-white fw-700 mt-4">VINIT BAPTIST</div>
          <div className="fo-24 text-white fw-700 mt-1">CEO & FOUNDER</div>
          <div className="fo-14 text-white mt-4 justify">India’s First MNU Certified Nutrition Fitness Coach, Vinit Baptist is the President and Founder of Optimum Wellness and he is well-versed with topics related to fitness and nutrition. He is always learning, teaching and coaching people the latest that has been proven in the field of fitness and nutrition.
            <br></br><br></br>He has educated numerous people about fitness and nutrition and that number is growing every day. You will find him talking to people about exercises, mobility, nutrition, weight training and strength and conditioning among other topics.
            <br></br><br></br>He has successfully set up four gyms across Kolkata under the brand name ZEST FITNESS STUDIO and plans to expand further globally. He is considered to be an authority and icon by various fitness professionals and he has conducted various successful workshops on nutrition, client assessment and exercise fundamentals.
            <br></br><br></br>He is on a quest to educate as many people as possible with evidence-based knowledge in nutrition and fitness sciences. </div>
        </div>
      </div>

      <div className='mt-5 pt-lg-5'></div>

      {
        !loading && (
          <>
            <CoachesSection />
            <DoctorsSection employees={employees.doctor} loading={loading}/>
            <InternsSection employees={employees.intern} loading={loading}/>
          </>
        )
      }

      <div className='aboutBottomContainer'>
        <div className='row m-0'>
          <div className='col-2 col-sm-3'></div>
          <div className='col-10 col-sm-9 text-center ms-auto me-auto mb-auto mt-sm-auto mt-15'>
            <div className='fo-50 bco fw-700 lg-40 mfo-18 mt-xl-5'>Ready To Take Care of <br></br>Your Wellness ?</div>
            <Link href="/contact">
              <button className='btn sendButton pulsating'>Contact us</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}


export default About;
